import axios from "axios";
import { supabase } from "../supabaseClient";

// CRM 2.0 settings (Settings › CRM 2.0 and Project › CRM 2.0). The server checks
// the permission and every field; a 400 carries { fields: { key: message } }.
const base = () => `${process.env.REACT_APP_PAYMENT_LINK_URL}crm2/settings`;
const auth = () => ({ headers: { Authorization: `Bearer ${supabase.auth.session()?.access_token}` } });
const data = (response) => response.data.data;

// Returns { sections, officeFields, options } (options: pick lists, plus wings / CRMs of the project)
async function getSettingsMeta(projectId) {
  return data(await axios.get(`${base()}/meta`, { ...auth(), params: projectId ? { projectId } : {} }));
}

// Returns { company, projectsOnCrm2, projectsOnTodaysFlow }
async function getCompanySettings(section) {
  return data(await axios.get(`${base()}/${section}`, auth()));
}

// Returns { company } (the saved row)
async function saveCompanySettings(section, values, lastUpdatedAt) {
  return data(await axios.put(`${base()}/${section}`, { values, lastUpdatedAt }, auth()));
}

// Returns { project, company, projectSettings } (projectSettings is null until the first save)
async function getProjectSettings(section, projectId) {
  return data(await axios.get(`${base()}/${section}/project/${projectId}`, auth()));
}

// Returns { projectSettings } (the saved row)
async function saveProjectSettings(section, projectId, useProjectValues, values, lastUpdatedAt) {
  return data(await axios.put(`${base()}/${section}/project/${projectId}`, { useProjectValues, values, lastUpdatedAt }, auth()));
}

// Sub-Registrar offices (Crm2SubRegistrarOffices)
async function getOffices() {
  return data(await axios.get(`${base()}/offices`, auth()));
}
async function addOffice(values) {
  return data(await axios.post(`${base()}/offices`, { values }, auth()));
}
async function saveOffice(officeId, values, lastUpdatedAt) {
  return data(await axios.put(`${base()}/offices/${officeId}`, { values, lastUpdatedAt }, auth()));
}

// Rider pool (M15-F2): Riders are users with the Rider role. Each row:
// { userId, name, mobile, isActive, officeIds, offices, openRegistrations, last_updated_at }
async function getRiders() {
  return data(await axios.get(`${base()}/riders`, auth()));
}
async function addRider(values) {
  return data(await axios.post(`${base()}/riders`, { values }, auth()));
}
async function saveRider(userId, values, lastUpdatedAt) {
  return data(await axios.put(`${base()}/riders/${userId}`, { values, lastUpdatedAt }, auth()));
}

// Team: CRMs who get new bookings of a project (Crm2ProjectCrms). Returns { project, crms }
async function getTeam(projectId) {
  return data(await axios.get(`${base()}/team/${projectId}`, auth()));
}
async function saveTeam(projectId, userIds) {
  return data(await axios.put(`${base()}/team/${projectId}`, { userIds }, auth()));
}

// Authorised signatory images (private bucket): upload → { path }; a 60-second link to show one → { url }
async function uploadSignatoryImage(file, signatoryId) {
  const form = new FormData();
  form.append("signatoryId", signatoryId);
  form.append("file", file);
  return data(await axios.post(`${base()}/signatories/image`, form, auth()));
}
async function getSignatoryImageLink(path) {
  return data(await axios.get(`${base()}/signatories/image-link`, { ...auth(), params: { path } }));
}

// Error text and per-field messages from a failed request.
function settingsError(err) {
  return {
    message: err?.response?.data?.error || err?.message || "Something went wrong",
    fields: err?.response?.data?.fields || {},
  };
}

export {
  getSettingsMeta, getCompanySettings, saveCompanySettings, getProjectSettings, saveProjectSettings,
  getOffices, addOffice, saveOffice, getRiders, addRider, saveRider, getTeam, saveTeam, uploadSignatoryImage, getSignatoryImageLink, settingsError,
};
